import type { RouteMiddleware, MiddlewareContext, RouteInfo } from '../types';
import type { OpenapiMiddlewareOptions } from './types';
import { createOpenapiRouter } from './router';

/**
 * Routes provided by OpenAPI middleware
 */
const OPENAPI_ROUTES: RouteInfo[] = [
  {
    method: 'GET',
    path: '/openapi.json',
    description: 'Serve enhanced OpenAPI specification with source code references',
  },
  {
    method: 'GET',
    path: '/openapi/spec',
    description: 'Serve OpenAPI specification for /openapi/*',
  },
];

/**
 * Creates OpenAPI middleware that serves enhanced openapi.json
 * Supports both rspack/webpack and Vite dev servers
 */
export function createOpenapiMiddleware(options: OpenapiMiddlewareOptions): RouteMiddleware {
  const { openapiFilePath, openapiSpecFilePath, enableEnhancement = true, serverDir } = options;

  const routes = openapiSpecFilePath
    ? OPENAPI_ROUTES
    : OPENAPI_ROUTES.filter((route) => route.path !== '/openapi/spec');

  return {
    name: 'openapi',
    mountPath: '/dev',
    routes,

    enabled: (context: MiddlewareContext) => context.isDev,

    createRouter: (context: MiddlewareContext) => {
      return createOpenapiRouter(
        {
          openapiFilePath,
          openapiSpecFilePath,
          enableEnhancement,
          serverDir,
        },
        context,
      );
    },
  };
}

// Re-export types and utilities
export type { OpenapiMiddlewareOptions, SourceInfo, EnhanceOptions, EnhanceResult } from './types';
export { enhanceOpenApiWithSourceInfo, parseApiRoutes } from './services';
